import type { AuthUser } from '@pixelworld/shared';
import { createContext, useContext } from 'react';

export type AuthState =
  { status: 'loading' } | { status: 'offline' } | { status: 'ready'; user: AuthUser | null };

export interface AuthContextValue {
  state: AuthState;
  /** Called after login or sign-up with the user the server returned. */
  signedIn: (user: AuthUser) => void;
  signOut: () => Promise<void>;
  /** Asks the server again, e.g. after a socket said the session is gone. */
  refresh: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) {
    throw new Error('useAuth must be used inside <AuthProvider>');
  }
  return value;
}
